import { Avatar } from "@mittwald/flow-remote-react-components";
import { ContextMenu, MenuItem } from "@mittwald/flow-remote-react-components";
import { Heading } from "@mittwald/flow-remote-react-components";
import { ListItemView } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import { IconFolderCancel } from "@tabler/icons-react";
import {
  IconEdit,
  IconUser,
  IconDelete,
} from "@mittwald/flow-remote-react-components";
import { DeleteDirectoryProtectionModal } from "./DeleteDirectoryProtectionModal";
import { useListAppInstallations } from "../../hooks/useListAppInstallations";
import { useOverlayController } from "@mittwald/flow-remote-react-components";
import { RenameDirectoryProtectionModal } from "./RenameDirectoryProtectionModal";
import { ChangeUsersDirectoryProtectionModal } from "./ChangeUsersDirectoryProtectionModal";

export interface DirectoryProtectionListProps {
  description: string;
  appInstallationId: string;
  users: { username: string }[];
  path: string;
}

export const DirectoryProtectionListItem = (props: {
  directoryProtection: DirectoryProtectionListProps;
  projectId: string;
}) => {
  const { directoryProtection } = props;

  const deleteModalController = useOverlayController("Modal", {
    reuseControllerFromContext: false,
  });

  const renameModalController = useOverlayController("Modal", {
    reuseControllerFromContext: false,
  });

  const changeUsersModalController = useOverlayController("Modal", {
    reuseControllerFromContext: false,
  });

  const appInstallations = useListAppInstallations(props.projectId);

  return (
    <ListItemView>
      <Avatar color="blue">
        <IconFolderCancel />
      </Avatar>

      <Heading>
        {directoryProtection.description} (
        {appInstallations.data.find(
          (a) => a.id == directoryProtection.appInstallationId,
        )?.description ?? "keine AppInstallation gefunden"}
        )
      </Heading>
      <Text>
        <strong>{directoryProtection.path}</strong> –{" "}
        {directoryProtection.users.length} Benutzer
      </Text>
      <ContextMenu selectionMode="navigation">
        <MenuItem
          onAction={() => {
            renameModalController.open();
          }}
        >
          <IconEdit />
          <Text>Passwortschutz umbenennen</Text>
        </MenuItem>
        <MenuItem
          onAction={() => {
            changeUsersModalController.open();
          }}
        >
          <IconUser />
          <Text>Benutzer anpassen</Text>
        </MenuItem>
        <MenuItem
          onAction={() => {
            deleteModalController.open();
          }}
        >
          <IconDelete />
          <Text>Passwortschutz löschen</Text>
        </MenuItem>
      </ContextMenu>
      <DeleteDirectoryProtectionModal
        controller={deleteModalController}
        path={directoryProtection.path}
        projectId={props.projectId}
        appInstallationId={directoryProtection.appInstallationId}
        appInstallationDescription={
          appInstallations.data.find(
            (a) => a.id == directoryProtection.appInstallationId,
          )?.description ?? "keine AppInstallation gefunden"
        }
      />
      <RenameDirectoryProtectionModal
        controller={renameModalController}
        projectId={props.projectId}
        directoryProtection={directoryProtection}
      />
      <ChangeUsersDirectoryProtectionModal
        controller={changeUsersModalController}
        projectId={props.projectId}
        directoryProtection={directoryProtection}
      />
    </ListItemView>
  );
};
